<template>
  <form class="nameform" @submit="next">
    <div class="content content--small">
      <transition appear name="fade">
        <p class="f-b text-grey text-center mb-10">
          Le domande possono sembrarti tante, ma sono davvero importanti!
        </p>
      </transition>
      <transition name="fade">
        <div v-show="firstBlockVisible">
          <hr class="my-8" />
          <p class="f-b text-grey mb-6" style="font-size: 14px">
            SCOPO DEL RAPPORTO
          </p>

          <div class="w-full mb-6">
            <div
              class="tnb-input"
              :class="{ error: $v.relationshipPurposeCarta.$error }"
            >
              <label for="relationshipPurposeCarta">Carta Prepagata</label>
              <select
                v-model.trim="$v.relationshipPurposeCarta.$model"
                class="tnb-select"
                id="relationshipPurposeCarta"
              >
                <option value=""></option>
                <option
                  v-for="domain in cartaPrepagataList"
                  :value="domain.code"
                  :key="domain.code"
                  >{{ domain.description }}</option
                >
              </select>

              <ValidationText :value="$v.relationshipPurposeCarta" />
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div v-show="relationshipPurposeCarta">
          <hr class="my-8" />

          <div class="w-full mb-6">
            <div
              class="tnb-input"
              :class="{ error: $v.gianos.fundsOrigin.$error }"
            >
              <label for="fundsOrigin">Provenienza dei fondi</label>
              <select
                v-model.trim="$v.gianos.fundsOrigin.$model"
                class="tnb-select"
                id="fundsOrigin"
              >
                <option value=""></option>
                <option
                  v-for="domain in fundsOriginList"
                  :value="domain.code"
                  :key="domain.code"
                  >{{ domain.description }}</option
                >
              </select>

              <ValidationText :value="$v.gianos.fundsOrigin" />
            </div>
          </div>

          <div class="w-full mb-6">
            <div
              class="tnb-input"
              :class="{ error: $v.gianos.annualIncome.$error }"
            >
              <label for="annualIncome">Reddito annuo lordo</label>
              <select
                v-model.trim="$v.gianos.annualIncome.$model"
                class="tnb-select"
                id="annualIncome"
              >
                <option value=""></option>
                <option
                  v-for="domain in annualIncomeList"
                  :value="domain.code"
                  :key="domain.code"
                  >{{ domain.description }}</option
                >
              </select>

              <ValidationText :value="$v.gianos.annualIncome" />
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          v-show="
            relationshipPurposeCarta &&
              gianos.fundsOrigin &&
              gianos.annualIncome
          "
        >
          <hr class="my-8" />
          <div class="w-full">
            <div class="tnb-input tnb-radio flex-col">
              <label for="politicallyExposed">
                Sei una persona politicamente esposta?
              </label>
              <span
                class="f-m text-grey label-info "
                @click="showModalPoliticamenteEsposta"
                >Perchè mi chiedi questo?</span
              >
              <div>
                <div class="tnb-radio-container mr-8">
                  <input
                    v-model="gianos.politicallyExposed"
                    type="radio"
                    id="yes"
                    name="politicallyExposed"
                    @click="showModalConfirmPoliticamenteEsposta"
                    :value="true"
                  />
                  <label for="yes">Si</label>
                </div>

                <div class="tnb-radio-container">
                  <input
                    v-model="gianos.politicallyExposed"
                    type="radio"
                    id="no"
                    name="politicallyExposed"
                    :value="false"
                  />
                  <label for="no">No</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          v-show="
            relationshipPurposeCarta && gianos.politicallyExposed !== null
          "
        >
          <hr class="my-8" />
          <p class="f-b text-grey mb-6" style="font-size: 14px">FATCA E CRS</p>

          <div class="w-full mb-6">
            <div class="tnb-input tnb-radio flex-col">
              <label for="usaCitizen"
                >Hai la cittadinanza statunitense?
                <div
                  class="icon icon-info icon--s float-right"
                  @click="showModalUSCitizenship"
                ></div>
              </label>
              <div>
                <div class="tnb-radio-container mr-8">
                  <input
                    v-model="fatcaCrs.usaCitizen"
                    type="radio"
                    id="yes"
                    name="usaCitizen"
                    :value="true"
                  />
                  <label for="yes">Si</label>
                </div>
                <div class="tnb-radio-container">
                  <input
                    v-model="fatcaCrs.usaCitizen"
                    type="radio"
                    id="no"
                    name="usaCitizen"
                    :value="false"
                  />
                  <label for="no">No</label>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full mb-6">
            <div class="tnb-input tnb-radio flex-col">
              <label for="usaResident"
                >Sei residente negli Stati Uniti?
                <div
                  class="icon icon-info icon--s float-right"
                  @click="showModalUSResidence"
                ></div
              ></label>
              <div>
                <div class="tnb-radio-container mr-8">
                  <input
                    v-model="fatcaCrs.usaResident"
                    type="radio"
                    id="yes"
                    name="usaResident"
                    :value="true"
                  />
                  <label for="yes">Si</label>
                </div>
                <div class="tnb-radio-container">
                  <input
                    v-model="fatcaCrs.usaResident"
                    type="radio"
                    id="no"
                    name="usaResident"
                    :value="false"
                  />
                  <label for="no">No</label>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full mb-6">
            <div class="tnb-input tnb-radio flex-col">
              <label for="foreignTaxation"
                >Sei residente all'estero fiscalmente?
                <div
                  class="icon icon-info icon--s float-right"
                  @click="showModalForeignResidence"
                ></div
              ></label>
              <div>
                <div class="tnb-radio-container mr-8">
                  <input
                    v-model="fatcaCrs.foreignTaxation"
                    type="radio"
                    id="yes"
                    name="foreignTaxation"
                    :value="true"
                  />
                  <label for="yes">Si</label>
                </div>
                <div class="tnb-radio-container">
                  <input
                    v-model="fatcaCrs.foreignTaxation"
                    type="radio"
                    id="no"
                    name="foreignTaxation"
                    :value="false"
                  />
                  <label for="no">No</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="page-footer mt-10">
      <button class="btn" :disabled="$v.$invalid" type="submit">
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ValidationText from "@/components/ValidationText";
import DocumentsService from "@/services/DocumentsService";
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";

export default {
  name: "ScopoRapporto",
  components: {
    ValidationText
  },
  data() {
    return {
      relationshipNatureCarta: "09", //this is a constant
      relationshipPurposeCarta: "",

      relationshipPurposeConto: "Gestione quotidiana",

      gianos: {
        annualIncome: "",
        fundsOrigin: "",
        politicallyExposed: null
      },

      fatcaCrs: {
        usaCitizen: null,
        usaResident: null,
        foreignTaxation: null
      },

      firstBlockVisible: false,
      activities: [],
      domains: []
    };
  },
  validations: {
    relationshipPurposeCarta: {
      required
    },
    gianos: {
      fundsOrigin: {
        required
      },
      annualIncome: {
        required
      },
      politicallyExposed: {
        required
      }
    },
    fatcaCrs: {
      usaCitizen: {
        required
      },
      usaResident: {
        required
      },
      foreignTaxation: {
        required
      }
    }
  },
  computed: {
    cartaPrepagataList: function() {
      return this.domains.filter(
        d => d.field === "SCOPO_RAPPORTO" && d.flow === "CARTA"
      );
    },
    fundsOriginList: function() {
      return this.domains.filter(
        d => d.field === "PROVENIENZA_FONDI" && d.flow === "L2"
      );
    },
    annualIncomeList: function() {
      return this.domains.filter(d => d.field === "REDDITO_ANNUO");
    }
  },
  mounted() {
    setTimeout(() => {
      this.firstBlockVisible = true;
    }, 1000);
    DocumentsService.getGianos().then(response => {
      this.activities = response.data.activities;
      this.domains = response.data.domains;
      this.fillUpInfoFromStorage();
    });
    window.moreDetails = this.moreDetails;
  },
  methods: {
    fillUpInfoFromStorage() {
      const details = JSON.parse(sessionStorage.getItem("cr_details"));
      //const gianos = details?.gianos?.pop();
      const fatca = details?.fatcaCrs?.pop();
      const gianosCarta = details?.gianos?.filter(
        g => g.relationshipNature === "09" || g.relationshipNature === "9"
      )[0];
      if (!gianosCarta) return;

      //this.relationshipPurposeCarta = gianosCarta.relationshipPurpose;
      this.gianos.fundsOrigin = gianosCarta.fundsOrigin;
      this.gianos.annualIncome = gianosCarta.annualIncome;
      this.gianos.politicallyExposed = gianosCarta.politicallyExposed;

      this.fatcaCrs.usaCitizen = fatca.usaCitizen;
      this.fatcaCrs.usaResident = fatca.usaResident;
      this.fatcaCrs.foreignTaxation = fatca.foreignTaxation;
    },
    showModalUSCitizenship() {
      this.$root.$emit("openModal", "genericModal", {
        title: "Definizione",
        message:
          "Per \"Cittadino Statunitense\" si intende la persona con cittadinanza statunitense, ivi compresa anche la persona nata negli Stati Uniti d'America, non più ivi residente o che non lo è mai stata (c.d. cittadinanza per nascita) tranne nel caso in cui la stessa abbia rinunciato alla Cittadinanza. In quest'ultimo caso è necessario fornire a Banca Profilo copia del Certificate of Loss of Nationality of the United States"
      });
    },
    showModalUSResidence() {
      this.$root.$emit("openModal", "genericModal", {
        size: "large",
        title: "Definizione",
        message: `Per “soggetto residente fiscale negli Stati Uniti” si intende, ai sensi della normativa FATCA, il soggetto che possiede almeno uno dei seguenti requisiti:
                  sia residente stabilmente negli Stati Uniti;
                  sia in possesso di un permesso di soggiorno permanente negli USA (ad es. “Green Card”), rilasciato dall’ Immigration and Naturalization Service;
                  abbia soggiornato negli Stati Uniti almeno per 31 giorni nell’anno di riferimento e per 183 giorni nell’arco temporale di un triennio (calcolati conteggiando tutti i giorni di presenza nell’anno di riferimento, un terzo dei giorni di presenza dell’anno precedente e un sesto dei giorni di presenza per il secondo anno precedente).
                  Non si considera tuttavia "soggetto residente fiscale negli Stati Uniti":
                  l'insegnante che ha soggiornato temporaneamente negli Stati Uniti se in possesso di una visa del tipo "j" o "Q";
                  lo studente che ha soggiornato temporaneamente negli Stati Uniti se in possesso di una visa del tipo "j", "Q" "F o M";
                  il soggetto che ha soggiornato temporaneamente negli Stati Uniti a seguito di incarichi di Governi esteri presso ad esempio ambasciate, consolati ed organizzazioni internazionali;
                  il coniuge o il figlio non sposato di età inferiore ai 21 anni di una delle persone descritte nei punti precedenti.`
      });
    },
    showModalForeignResidence() {
      this.$root.$emit("openModal", "genericModal", {
        size: "large",
        title: "Definizione",
        message: `Per "residenza fiscale" si intende, ai fini della presente dichiarazione, lo Stato in cui una persona, in virtù della legislazione di quel determinato Stato, è assoggettata ad imposta, a motivo del suo domicilio, della sua residenza o di ogni altro criterio di natura analoga. Tale espressione non comprende le persone che sono assoggettate ad imposta in tale Stato soltanto per il reddito che esse ricavano da fonti situate in detto Stato o per il patrimonio ivi situato.`
      });
    },
    showModalPoliticamenteEsposta() {
      this.$root.$emit("openModal", "genericModal", {
        size: "large",
        title: "Definizione",
        message: `Rientrano nella definizione di “Persone Politicamente Esposte” (PEP,
          ovvero persone fisiche che occupano o che, nell’ultimo anno, hanno
          occupato importanti cariche pubbliche) il Presidente della Repubblica,
          Presidente del Consiglio, Ministro, Vice-Ministro e Sottosegretario,
          Presidente di Regione, assessore regionale, Sindaco di capoluogo di
          provincia o città metropolitana, Sindaco di comune con popolazione non
          inferiore a 15.000 abitanti; Deputato, senatore, parlamentare europeo,
          consigliere regionale; Membro degli organi direttivi centrali di
          partiti politici; Giudice della Corte Costituzionale, magistrato della
          Corte di Cassazione o della Corte dei conti, consigliere di Stato e
          altri componenti del Consiglio di Giustizia Amministrativa per la
          Regione siciliana; Membro degli organi direttivi delle banche centrali
          e delle Autorità indipendenti; Ambasciatore, incaricato d’affari,
          ufficiale di grado apicale delle forze armate; Componente degli organi
          di amministrazione, direzione o controllo delle imprese controllate,
          anche indirettamente, dallo Stato italiano o da uno Stato estero;
          Componente degli organi di amministrazione, direzione o controllo
          delle imprese partecipate dallo Stato italiano o da uno Stato estero,
          in misura prevalente o totalitaria, dalle Regioni, da comuni,
          capoluoghi di provincia e città metropolitane e da comuni con
          popolazione complessivamente non inferiore a 15.000 abitanti;
          Direttore generale di ASL e di azienda ospedaliera, di azienda
          ospedaliera universitaria e degli altri enti del servizio sanitario
          nazionale; Direttore, vicedirettore e membro dell’organo di gestione o
          soggetto svolgenti funzioni equivalenti in organizzazioni
          internazionali; cariche analoghe anche in Stati esteri (sono da
          ricomprendere anche i genitori, il coniuge o persona legata in unione
          civile o convivenza di fatto, i figli o loro coniugi/legati in unione
          civile o convivenza di fatto e soggetti che intrattengano stretti
          legami d’affari del soggetto qualificato come PEP).`
      });
    },
    showModalConfirmPoliticamenteEsposta() {
      this.$root.$emit("openModal", "genericModal", {
        size: "large",
        title: "Attenzione",
        htmlMessage: `

        <p>Hai indicato di essere una <b>persona politicamente esposta</b>, questo comporterà un prolungarsi dei tempi di gestione della tua registrazione.
        <br><br>Sei sicuro di ricoprire:</p>

        <ul style="padding: 10px; margin: 0 0 0 15px; list-style: disc;">
          <li>cariche pubbliche (es. cariche istituzionali o politiche)</li>
          <li>ruoli direttivi in società partecipate dallo stato Italiano o da uno stato Estero</li>
          <li>cariche direttive di ASL e/o enti SSN</li>
        </ul>


        <p>
          In caso contrario seleziona NO alla domanda "Sei una persona politicamente esposta?".
          <br> <br>Per maggiori dettagli <span class="link" onclick="moreDetails()">clicca qui</span>.
        </p><br><br>`
      });
    },
    moreDetails() {
      this.$root.$emit("closeModal", "genericModal")
      this.showModalPoliticamenteEsposta();
    },
    async next() {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      if (this.fatcaCrs.usaCitizen) {
        UtilityService.showErrorModal(
          "Non è possibile proseguire per gli utenti cittadini USA. Per maggiori informazioni contattaci"
        );
        this.loading = false;
        return;
      }

      if (this.fatcaCrs.usaResident) {
        UtilityService.showErrorModal(
          "Non è possibile proseguire per gli utenti con residenza USA. Per maggiori informazioni contattaci"
        );
        this.loading = false;
        return;
      }

      if (this.fatcaCrs.foreignTaxation) {
        UtilityService.showErrorModal(
          "Non è possibile proseguire per gli utenti aventi residenza all'estero. Per maggiori informazioni contattaci"
        );
        this.loading = false;
        return;
      }

      this.$store.commit("setUser", {
        gianos: {
          ...this.$store.state.user.gianos,
          ...this.gianos
        },
        fatcaCrs: this.fatcaCrs
      });

      const req = {
        gianos: {
          ...this.$store.state.user.gianos,
          relationshipNature: this.relationshipNatureCarta,
          relationshipPurpose: this.relationshipPurposeCarta
        },
        fatcaCrs: this.$store.state.user.fatcaCrs
      };

      try {
        await RegistrationService.saveFatcaGianos(req);
        await RegistrationService.upgradeRegistrationProgress(2);

        this.$root.$emit("submitStep");
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.tnb-app .tnb-radio > label {
  width: 100%;
}
</style>
